import { Paper } from "@mantine/core";
import { bankAccountApi } from "apis/bankAccountApi";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { BankAccountCreateBodyType } from "constants/types/bankAccount";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/BankAccount/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import BankAccountFormFields from "../BankAccountFormFields/BankAccountFormFields";
import { createValidationSchema } from "./config";

interface CreateFormProps {
  onClose?: () => void;
  mutate?: () => void;
}

const CreateForm: FC<CreateFormProps> = ({ onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik<BankAccountCreateBodyType>({
    initialValues: {
      code: "",
      bankName: "",
      accountNumber: "",
      accountHolder: "",
      isActive: true,
    },
    validationSchema: createValidationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const res = await bankAccountApi.create(values);
        if (res.data.success) {
          notification.success({ title: "Tạo tài khoản ngân hàng thành công" });
          onClose?.();
          mutate?.();
          formik.resetForm();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({
          title: "Tạo tài khoản ngân hàng thất bại",
          message: error?.error?.message,
        });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.CREATE} onSubmit={formik.handleSubmit}>
          <BankAccountFormFields formik={formik} isCreateMode />
        </form>
      </Paper>
    </Loading>
  );
};

export default CreateForm;
